import * as React from 'react';
import '../assets/styles/Footer/footer.css'

const Footer: React.FC = () => {
    return <>
        <div className='footer'>
            <div className="direitos">
            <p>&copy; 2024 Mk2. Todos os direitos reservados.</p>
            </div>

        </div>
    </>
}

export default Footer;